var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.ifWidth)?_c('header',[_c('headIn',{attrs:{"nowData":_vm.nowData}})],1):_vm._e(),_c('main',{staticClass:"main-content"},[_c('router-view')],1),(_vm.ifWidth)?_c('footer',[_c('bottomIn',{attrs:{"nowBottom":_vm.nowBottom}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }